module.exports = __webpack_public_path__ + "img/home_verdian_1.dfea46db.jpg";